import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: false,
    userData: null,
    Authenticated: false,
    user: null,
    userCode: null,
    token: null,
    loginSessionID: null,
    error: null,
    loading: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        isAuthenticate: (state, action) => {
            state.Authenticated = action.payload
        },
        LogOut: (state, action) => {
            state.status = false;
            state.userData = null;
        },
        setSubLoading: (state, action) => {
            state.loading = action.payload;
        }
    },
});

export const { LogOut, UserLogin, isAuthenticate, setIsMultipleCompanyAccess, setSubLoading } = authSlice.actions

export default authSlice.reducer